module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1030-4c3b8a9439cf3398634b3d0632d1aedb.png";